import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import axios from 'axios';

import CommonButton from '../common/button/Button';
import './settings.css';

const ScreenSettingPage: React.FC = () => {

    //@ts-ignore
    const config = window.config;
    const apiBaseURL = config?.server || 'http://18.217.95.31:8080';
    const { t } = useTranslation('translation');
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md')); // md = 900px and up
    const [loading, setLoading] = React.useState<boolean>(false);
    const [desktopOnlyAlertOpen, setDesktopOnlyAlertOpen] = React.useState(false);
    const navigate = useNavigate();
    let localData = localStorage.getItem('UserData');
    const shopownerData = localData ? JSON.parse(localStorage.getItem('UserData') || "") : null;
    const userSubscription = localStorage.getItem("userSubscriptionDetails");
    const userSubscriptionDetails = userSubscription? JSON.parse(localStorage.getItem("userSubscriptionDetails") || ""): null;

    const getSettingsDetails = (value: any, option: string) => {
        setLoading(true);
        let localData = localStorage.getItem('UserData');
        const userData = localData ? JSON.parse(localStorage.getItem('UserData') || "") : null;
        axios.get(`${apiBaseURL}/api/settings/fetchSettings?id=${shopownerData?.uId}&screenNumber=${value}`).then((data: any) => {
            if (data?.status === 200) {
                let settingsDetail = data?.data?.settings;

                let settings = {
                  settingId: settingsDetail?.id,
                  screenNumber: settingsDetail?.screenNumber,
                  headerFooterStyle: settingsDetail?.headerFooterStyle,
                  ticketsCount: settingsDetail?.ticketsCount,
                  rows: settingsDetail?.rows,
                  column: settingsDetail?.column,
                  emptyTicketsDisplay: settingsDetail?.emptyTicketsDisplay,
                  backgroundType: settingsDetail?.backgroundType,
                  backgroundValue: settingsDetail?.backgroundValue,
                  orientation: settingsDetail?.orientation ?? "LANDSCAPE",
                };

                if (data?.data?.screenOneSettings) {
                  let screenOneSettings = {
                    ticketsCount: data?.data?.screenOneSettings?.ticketsCount,
                  };

                  localStorage.setItem("screenOneSettings", JSON.stringify(screenOneSettings));
                }

                localStorage.setItem('settings', JSON.stringify(settings));
            }
        }).catch((err: any) => {
            console.log("err", err)
        }).finally(() => {
            setLoading(false);
            if (userData && option === "dashboard") {
                if (userData?.role === "ADMIN") {
                    navigate('/admin/dashboard');
                }
                else if (userData?.role === "SHOPOWNER") {
                    navigate('/shopOwner/dashboard');
                }
            } else {
                // the screen number travels in the URL as well, so the display does not
                // depend on what another tab last wrote to localStorage
                navigate(`/lottery?screen=${value}`);
            }
        })
    }

    const handleSubmit = async (value: any, option: string) => {
        // On mobile/small screens, Screen 1 & Screen 2 are desktop-only
        if (!isDesktop && (option === "screenOne" || option === "screenTwo")) {
            setDesktopOnlyAlertOpen(true);
            return;
        }

        localStorage.setItem('screenNumber', JSON.stringify(value));
        await getSettingsDetails(value, option);
    }

    React.useEffect(() => {
        if(userSubscriptionDetails.paymentStatus === "PENDING") {
            navigate("/pendingPayment")
        }
    }, [userSubscriptionDetails]);

    return (
        <>
            <Grid className='screen-setting-page p-4'>
                <Grid className='h-[80vh] flex justify-center items-center mt-4'>
                    <div className='screen-setting-buttons'>
                        {
                            loading ? (
                                <CircularProgress size={20} thickness={6} color='inherit' />
                            ) : (
                                <>
                                    <div className='screen-setting-btn-wrap'>
                                        <CommonButton
                                            id='login-button'
                                            className='screen-button'
                                            variant='contained'
                                            onClick={() => {
                                                handleSubmit(1, "screenOne");
                                            }}
                                        >
                                            {t('screen', { screenCount: 1 })}
                                        </CommonButton>
                                    </div>
                                    <div className='screen-setting-btn-wrap'>
                                        <CommonButton
                                            id='login-button'
                                            className='screen-button'
                                            variant='contained'
                                            onClick={() => {
                                                handleSubmit(2, "screenTwo");
                                            }}
                                        >
                                            {t('screen', { screenCount: 2 })}
                                        </CommonButton>
                                    </div>
                                    <div className='screen-setting-btn-wrap'>
                                        <CommonButton
                                            id='login-button'
                                            className='screen-button'
                                            variant='contained'
                                            onClick={() => {
                                                handleSubmit(1, "dashboard");
                                            }}
                                        >
                                            {t('dashboard')}
                                        </CommonButton>
                                    </div>
                                </>
                            )
                        }
                    </div>
                </Grid>
            </Grid>

            <Dialog
                open={desktopOnlyAlertOpen}
                onClose={() => setDesktopOnlyAlertOpen(false)}
                aria-labelledby="screen-desktop-only-alert-title"
                aria-describedby="screen-desktop-only-alert-description"
                PaperProps={{
                    sx: {
                        borderRadius: 2,
                        boxShadow: 24,
                        minWidth: { xs: "80vw", sm: 360 },
                    },
                }}
            >
                <DialogTitle id="screen-desktop-only-alert-title" sx={{ fontWeight: 600, fontSize: "1.25rem" }}>
                    Desktop only
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="screen-desktop-only-alert-description">
                        This option is available only on Desktop.
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2 }}>
                    <Button
                        variant="contained"
                        onClick={() => setDesktopOnlyAlertOpen(false)}
                        sx={{ textTransform: "none", fontWeight: 600 }}
                    >
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default ScreenSettingPage;